<template>
  <section class="content" style="background-color: #EBECF1">
    <div>
      <loading :active.sync="isLoading" :can-cancel="true" :is-full-page="true"></loading>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="box box-info">
          <div class="box-header">
            <h3 class="fuente box-title p-t-10">MANTENIMIENTO DE USUARIOS CAS: <a style="font-size: 18px; color: red">{{
              cont }}</a></h3>
          </div>
          <div class="box-body">
            <form role="form">
              <div class="row">
                <div class="fuente col-xs-12 table-responsive">
                  <div class="box-body">
                    <table aria-describedby="tablaDetalle_info" role="grid" id="tablaDetalle"
                      class="fuente fs-12 table table-bordered table-striped dataTable">
                      <thead>
                        <tr role="row">
                          <th aria-label="USUARIO" aria-controls="tablaDetalle" tabindex="0" class="sorting">USUARIO</th>
                          <th aria-label="CORREO" aria-controls="tablaDetalle" tabindex="0" class="sorting">CORREO</th>
                          <th aria-label="EDITAR" aria-controls="tablaDetalle" tabindex="0"
                            class="sorting table-center-header">EDITAR</th>
                          <th aria-label="ANULAR" aria-controls="tablaDetalle" tabindex="0"
                            class="sorting table-center-header">ANULAR</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="even" role="row" v-for="item in trabs">
                          <td>{{ item.usuario }}</td>
                          <td>{{ item.correo }}</td>
                          <td class="table-center-header"><span style="cursor:pointer" class="badge bg-blue"
                              data-toggle="modal" @click="verData(item)" data-target="#modalNuevo">O</span></td>
                          <td class="table-center-header"><span style="cursor:pointer" class="badge bg-red"
                              data-toggle="modal" @click="verData(item)" data-target="#modalAnular">X</span></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </form>
            <div class="modal fade" id="modalAnular" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <form>
                    <div class="modal-header">
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                          aria-hidden="true">X</span></button>
                      <h4 class="fuente modal-title m-t-10" id="myModalLabel">¿DESEA ANULAR EL USUARIO?</h4>
                    </div>
                    <div class="fuente modal-body">
                      Se anulará el usuario {{ user }} <br />
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="fuente btn btn-danger fs-13" @click="anular()"
                        data-dismiss="modal">Anular Usuario</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="modal fade" id="modalNuevo" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <form>
                    <div class="modal-header">
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                          aria-hidden="true">X</span></button>
                      <h4 class="fuente modal-title m-t-10" id="myModalLabel">ACTUALIZAR DATOS DE USUARIO</h4>
                    </div>
                    <div class="fuente modal-body fs-12">
                      <div class="row">
                        <div class="col-md-6">
                          Usuario
                          <input type="text" class="form-control m-t-10 m-b-10" required="true" v-model="user"
                            placeholder="Ingrese Usuario" />
                        </div>
                        <div class="col-md-6">
                          Password
                          <input type="password" class="form-control m-t-10" required="true" v-model="clave"
                            placeholder="Ingrese Clave" />
                        </div>
                      </div>
                    </div>
                    <div class="fuente col-md-12"
                      style="color: red; font-size: 12px; padding-top: 10px; padding-bottom: 15px">
                      El Password debe contener la primera letra de su nombre y apellido paterno en mayúsculas. Seguido el
                      guión abajo y por último su número de DNI.
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="fuente btn btn-primary fs-13" @click="editar()"
                        data-dismiss="modal">Guardar Cambios</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

require('moment')
import 'datatables.net'
import 'datatables.net-bs'
import axios from 'axios'
import $ from 'jquery'
import { apiURL, apiLOGIN } from '@/store/state'
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
//import App from '../App.vue';
import App from '@/components/App.vue';
import moment from 'moment';

export default {
  name: 'Tables',
  data() {
    return {
      trabs: [],
      trabs1: [],
      trabs2: [],
      usuario: [],
      cont: '',
      user: '',
      clave: '',
      isLoading: false,
      fullPage: true,
      tiempoActual: null,
      tiempoTokenExp: null,
    }
  },
  components: {
    Loading
  },
  mounted() {
    //this.tiempoActual = new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' });
    //this.tiempoTokenExp = localStorage.getItem('TokenExpirationTime')
    this.tiempoActual = moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a");
    this.tiempoTokenExp = moment(localStorage.getItem('TokenExpirationTime'), "D/M/YYYY, h:mm:ss a");
    
    if (!this.$session.exists('token')) {
      App.methods.logout.call(this);
      return;
    }

    if (this.tiempoActual < this.tiempoTokenExp) {
      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      // Realizar la validación con la API
      axios.get(`${apiLOGIN}/operaciones/app/GESU/usuariosCas`)
        .then(response => {
          
          if (response.data.codError === 1 || response.data.desError === 'ok') {
            // La validación es exitosa, continuar con la carga de datos
            this.carga();
          } else {
            // La validación no es exitosa, redirigir a la vista anterior
            //console.log("Usuario No Autorizado")
            //this.$router.go(-1);
            this.alertaError();
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            // Manejar el caso de error de autorización
            //this.$router.go(-1);
            this.alertaError401();
          } else if (error.response && error.response.status === 403) {            
            //this.$router.go(-1);
            this.alertaError();
          } else if (error.response && error.response.status === 500) {
            //this.$router.go(-1); 
            this.alertaError500();
          } else {
            console.error(error);
            //this.$router.go(-1);
            this.alertaError401();
          }
        });
    } else {
      this.alertaError401();
    }
  },
  methods: {
    carga: function () {
      this.isLoading = true;
      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      axios.get(
        //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/usuarios/lista/0/100',
        `${apiURL}/usuarios/lista`,
      ).then(response => {
        this.trabs = response.data   
        
        $('#tablaDetalle').dataTable().fnDestroy()
        this.$nextTick(() => {
          $('#tablaDetalle').DataTable({
            stateSave: true, // Guarda el estado y la paginación de la tabla
            'stateSaveParams': function (settings, data) {
              data.length = 25; // Establece la longitud de la página
            },
            //lengthMenu: [10, 25, 50, 100], // Definir las opciones de registros por página
            pageLength: 25, // Establecer el número de registros por página al iniciar
            'oLanguage': {
              'sSearch': 'Buscar',
              'sInfo': 'Mostrando _START_ al _END_ de _TOTAL_ registros',
              'sEmptyTable': 'Sin Data',
              'sZeroRecords': 'No se encontraron coincidencias',
              'sInfoFiltered': '(filtrado de un total de _MAX_ registros)',
              'sLengthMenu': '_MENU_ Registros por página',
              'sInfoEmpty': 'Mostrando 0 al 0 de 0 registros',
              'oPaginate': {
                'sPrevious': 'Anterior',
                'sNext': 'Siguiente'
              }
            }
          })
        })
        this.cont = this.trabs.length   
        this.isLoading = false;

        /*
        axios.defaults.headers.common['Authorization'] = this.$session.get('token')
        axios.get(
          //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/usuarios/lista/100/100',
          `${apiURL}/usuarios/lista/100/100`,
        ).then(response => {
          this.trabs1 = response.data
          axios.defaults.headers.common['Authorization'] = this.$session.get('token')
          axios.get(
            //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/usuarios/lista/200/100',
            `${apiURL}/usuarios/lista/200/100`,
          ).then(response => {
            this.trabs2 = response.data
            //////////////////////////////////            
          })
            .catch(error => {
              if (error.response.status === 401) {
                this.isLoading = false;
                App.methods.logout.call(this);
              }
            })
        })
          .catch(error => {
            if (error.response.status === 401) {
              this.isLoading = false;
              App.methods.logout.call(this);
            }
          })
          */
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            this.isLoading = false;
            App.methods.logout.call(this);
          }
        })
    },
    editar: function () {
      if (moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a") < this.tiempoTokenExp) {
        if (this.clave != '' && this.user != '') {
          this.isLoading = true;
          axios.post(
            //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/usuario/add',
            `${apiURL}/operaciones/usuario/add`,
            {
              'idUsuario': this.usuario[0].idUsuario,
              'nomUsuario': this.user,
              'clave': this.clave,
              'idTrabajador': this.usuario[0].idTrabajador,
              'flagActivo': this.usuario[0].flagActivo,
              'usuario': this.$session.get('user')
            }
          ).then(response => {
            this.isLoading = false;
            this.carga();
          })
            .catch(error => {
              if (error.response && error.response.status === 401) {
                this.isLoading = false;
                App.methods.logout.call(this);
              }
            })
        } else { }
      } else {
        this.alertaError401();
      }
    },
    anular: function () {
      if (moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a") < this.tiempoTokenExp) {
        this.isLoading = true;
        axios.post(
          //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/usuario/add',
          `${apiURL}/operaciones/usuario/add`,
          {
            'idUsuario': this.usuario[0].idUsuario,
            'nomUsuario': this.usuario[0].nomUsuario,
            'clave': this.usuario[0].clave,
            'idTrabajador': this.usuario[0].idTrabajador,
            'flagActivo': '0',
            'usuario': this.$session.get('user')
          }
        ).then(response => {
          this.isLoading = false;
          this.carga();
        })
          .catch(error => {
            if (error.response.status === 401) {
              this.isLoading = false;
              App.methods.logout.call(this);
            }
          })
      } else {
        this.alertaError401();
      }
    },
    verData: function (item) {
      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      //axios.get('https://tomcat.sedetc.gob.pe/cas-services-0.0.2/usuarios/trabajador/' + item.idPersona
      axios.get(`${apiURL}/usuarios/trabajador/` + item.idPersona
      ).then(response => {
        this.usuario = response.data
        this.user = this.usuario[0].nomUsuario
        this.clave = this.usuario[0].clave
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    alertaError() {
      Swal.fire({
        icon: 'error',
        title: 'Usuario No Autorizado',
        text: 'No tienes permisos para acceder.',
        timer: 2000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {
        // Se redirecionará a la vista anterior cuando se cierre el cuadro de diálogo.
        this.$router.go(-1);
      });
    },
    alertaError401() {
      Swal.fire({
        icon: 'error',
        title: 'La sesión ha expirado',
        //text: 'Vuelve a iniciar sesión.',
        footer: '<a href="#">Vuelve a iniciar sesión.</a>',
        timer: 3000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {                
        //this.$session.destroy()
        //this.$router.push('/login')
        App.methods.logout.call(this); ///Cierra sesión 
      });
    },
    alertaError500() {
      Swal.fire({
        icon: 'error',
        title: 'Error interno del servidor',
        text: 'Ocurrió un error. Por favor, inténtalo de nuevo más tarde..',
        timer: 5000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {
        // Se redirecionará a la vista anterior cuando se cierre el cuadro de diálogo.
        this.$router.go(-1);
      });
    },
  },
}
</script>

<style>
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}

.datetime-picker input {
  height: 2em !important;
  border: 1px solid #fff !important;
}
</style>


// WEBPACK FOOTER //
// UsuariosCas.vue?18d086cc